import { createdATFilter } from 'modules/common/constants/filters/common.filters';

export const warehouseAreaFilters = [createdATFilter];
